<template>
    <div class="container">
      <br>
  <!--  <b-row class="justify-content-center">
        <b-col md="10">
            <b-card no-body class="p-3">
              <b-card-body>
                <img src="../assets/intensWinter.png" width="100%">
              </b-card-body>
            </b-card>
        </b-col>
      </b-row>-->
  <!--    <b-row class="justify-content-center">
        <b-col md="10">
            <b-card no-body class="p-3">
              <b-card-body>
              <b> Практические курсы с 1 по 11  мая.</b><br><br>

⚡️ Занятия каждый день по 2 часа: 1 час математика и 1 час русский язык/кыргыз тили.<br>
⚡️ Занятия только с аналогичными вопросами, которые встречаются на ОРТ.

<br><br><b>
  🕙 1-смена: 8:30-10:30<br>
  🕙 2-смена: 11:00-13:00<br>
  🕙 3-смена: 14:00-16:00<br>
  🕙 4-смена: 16:20-18:20<br></b>
<br><br>
⚡️ Стоимость курса 4500 сом.<br>
⚡️ Все материалы включены в стоимость<br>

<br><br>
📍 Адрес: ул Ж.Боконбаева 16 ( ориентир 67 школа)
</b-card-body>
            </b-card>
        </b-col>
      </b-row>

    -->
      <b-row class="justify-content-center">
        <b-col md="10">
            <b-card no-body class="p-3">
              <b-card-body>
                  <form>
                   <br>
                    <p class="text-muted">Введите свой номер телефона</p>
                    <b-input-group class="mb-3">
                      <b-input-group-prepend><b-input-group-text><i class="icon-phone"></i></b-input-group-text></b-input-group-prepend>
                      <b-form-input type="number" class="form-control" placeholder= "0777111111" v-model="phoneNumber"/>
                    </b-input-group>
                    <b-row>
                      <b-col>
                        <b-button variant="primary" class="btn-block px-4" v-on:click="findResults()">Найти результат</b-button>
                      </b-col>
                    </b-row>
                </form>
              </b-card-body>
            </b-card>
        </b-col>
      </b-row>
    

      <b-modal v-model="noResult" hide-footer >
            <div class="container">
              <br>
                 <p class="red"><b>К сожалению ничего не найдено.</b> </p>
                 <p><i>Возможные причины: </i></p>
                 <p>1. Результаты еще не выгружены.</p>
                 <p>2. Не правильно заполнен номер телефона/теста.</p>
                  <br>
                </div>
          </b-modal>

      <div class="row justify-content-center" v-if="showResultTable">
        <b-col md="10">
          <transition name="slide">
            <b-card>
                <table class="table table-striped table-hover">
                  <tbody>
                    <tr>
                         <th></th>
                      <th>Дата</th>
                      <th>Тест</th>
                   
                    </tr>
                    <tr v-for="item in items" :key=item.resultId>
                       <td>
                        <button class="btn btn-warning btn-sm" v-on:click="calculateResult(item)"><i class="fa fa-info"></i></button>
                      </td>
                      <td>{{item.testDate}}</td>
                      <td>{{item.testName}}</td>
                     
                    </tr>
                  </tbody>
                </table>
            </b-card>
          </transition>
        </b-col>
      </div>

      <div class="row justify-content-center" v-if="showDetailTables">
        <b-col md="10">
          <transition name="slide">
            <b-card>
              <div slot="header" v-html="rus_to_latin(studentName)"></div>
                <table class="table table-striped table-hover">
                  <tbody>
                     <tr>
                         <th></th>
                      <th>Предмет</th>
                      <th>К.В.</th>
                      <th>К.П.</th>
                      <th>Ба.</th>
                    </tr>
                    <tr>
                      <td>
                        <button class="btn btn-success btn-sm" v-on:click="selectRow(0, 60)"><i class="fa fa-info"></i></button>
                      </td>
                      <td>Математика</td>
                      <td>60</td>
                      <td>{{mathResult}}</td>
                      <td>{{mathPoints}}</td>
                    </tr>
                    <tr>
                      <td>
                        <button class="btn btn-success btn-sm" v-on:click="selectRow(60, 90)"><i class="fa fa-info"></i></button>
                      </td>
                      <td>Аналогии</td>
                      <td>30</td>
                      <td>{{analogyResult}}</td>
                     <td>{{analogyPoints}}</td>
                    </tr>
                    <tr>
                      <td>
                        <button class="btn btn-success btn-sm" v-on:click="selectRow(90, 120)"><i class="fa fa-info"></i></button>
                      </td>
                      <td>Чтение и понимание</td>
                      <td>30</td>
                      <td>{{readingResult}}</td>
                       <td>{{readingPoints}}</td>
                    </tr>
                    <tr>
                       <td>
                        <button class="btn btn-success btn-sm" v-on:click="selectRow(120, 150)"><i class="fa fa-info"></i></button>
                      </td>
                      <td>Грамматика</td>
                      <td>30</td>
                      <td>{{grammarResult}}</td>
                    <td>{{grammarPoints }}</td>
                    </tr>
                    <tr>
                      <td><b></b></td>
                      <td>Общий балл</td>
                      <td><b></b></td>
                      <td><b></b></td>
                      <td><b>{{totalPoints }}</b></td>
                    </tr>
                  </tbody>
                </table>
                   К.В.- Количество вопросов<br>
                    К.П.- Количество правильных ответов<br>
                    Ба.- Баллы<br>
            </b-card>
          </transition>
        </b-col>
      </div>

      <div class="row justify-content-center"  v-if="showTopicsTable">
        <b-col md="10">
          <transition name="slide">
            <b-card>
                <table class="table table-striped table-hover">
                  <tbody>
                    <tr>
                      <th>Но</th>
                      <th>Тема</th>
                      <th></th>
                    </tr>
                    <tr v-for="item in topics" :key=item.keyId>
                      <td>{{item.questionNo}}</td>
                      <td>{{item.topic}}</td>
                      <td v-if="ifCorrect(item)"><i class="fa fa-check-circle green-color" ></i></td>
                      <td v-if="ifWrong(item)"><i class="fa fa-plus-circle red-color"></i></td>                      
                    </tr>
                  </tbody>
                </table>
            </b-card>
          </transition>
        </b-col>
      </div>

    </div>
</template>

<script>
import TestService from '../services/testservice';

export default {
  name: 'dashboard',
  components: {
  },
  data: function () {
    return {
      items: [],
      keys:[],
      topics:[],
      phoneNumber:'',
      caption:'Результаты',
      mathResult:'',  
      analogyResult:'',
      readingResult:'',
      grammarResult:'', 
      showDetailTables: false,  
      showTopicsTable: false,  
      showResultTable: false, 
      studentName:'',
      noResult: false
    }
  },
  computed:{
    mathPoints: function () {
      return Math.round(this.mathResult*66/60+1);
    },
     analogyPoints: function () {
      return Math.round(this.analogyResult*58/30+5);
    },
     readingPoints: function () {
      return Math.round(this.readingResult*53/30+5);
    },
    grammarPoints: function () {
      return Math.round(this.grammarResult*52/30+5);
    },
    totalPoints: function () {
      return Math.round(this.grammarResult*52/30+5)+Math.round(this.analogyResult*58/30+5)+Math.round(this.readingResult*53/30+5)+Math.round(this.mathResult*66/60+1);
    },
    totalCorrects: function () {
      return this.grammarResult+this.readingResult+this.analogyResult+this.mathResult;
    },
    logedIn()
    {
       if(this.$store.getters.getCurrentUser==null || this.$store.getters.getCurrentUser=='')
          return true;
        else
          return false;
    }
  },
  methods: {
    ifCorrect(item)
    {
      if(item.topicLong =='+')
        return true;
      else
        return false;
    },
    ifWrong(item)
    {
      if(item.topicLong =='-')
        return true;
      else
        return false;
    },
    selectRow(begin, end)
    {      
      this.topics = [];
      var count = 0;
      for ( var i = begin; i < end; ++i ) {
          this.topics[count] = this.keys[i];
          this.topics[count].questionNo = count+1;
          count++;
        }
      this.showTopicsTable = true;
    },
    findResults()
    {     
        this.showResultTable = false;
        this.showDetailTables = false;
        this.showTopicsTable = false;
        TestService.listResults(this.phoneNumber).then((response)=>{
          this.items = response;
          if(this.items.length>0)
            this.showResultTable = true;              
          else
            this.noResult = true;
        });
    },
    calculateResult(item)
    {
        this.mathResult=0;
        this.analogyResult=0;
        this.readingResult=0;
        this.grammarResult=0;

        this.studentName = item.studentName;

        TestService.listTestKeys(item.testName+item.studentLang).then((response)=>{
          this.keys = response;

          this.mathResult=0;
          this.analogyResult=0;
          this.readingResult=0;
          this.grammarResult=0;

          if(this.keys.length>0)
            this.showDetailTables=true;

          var counter = 0;
           this.keys.forEach(element => {

              if(element.answer==item.studentAnswer.substring(counter, counter+1))
              {
                  element.topicLong = '+';
                  if(counter<60)
                    this.mathResult++;
                  else if(counter>59 && counter<90)
                    this.analogyResult++;
                  else if(counter>89 && counter<120)
                    this.readingResult++;
                  else if(counter>119 && counter<150)
                    this.grammarResult++;
              } 
              else
                  element.topicLong = '-';

              if(element.answer=='B')
                element.answer = 'Б';
              else if(element.answer=='C')
                element.answer = 'В';
              else if(element.answer=='D')
                element.answer = 'Г';              

              counter++;
           }); 

        });
    },
    rus_to_latin (str) {
    
      var ru = {
          'A': 'А', 'B': 'Б', 'V': 'В', 'G': 'Г', 'D': 'Д', 
          'E': 'Е', ']': 'Ө', 'J': 'Ж', 'Z': 'З', 'I': 'И', 
          'K': 'К', 'L': 'Л', 'M': 'М', 'N': 'Н', 'O': 'О', 
          'P': 'П', 'R': 'Р', 'S': 'С', 'T': 'Т', 'U': 'У', 
          'F': 'Ф', 'H': 'Х', 'W': 'Y', '[': 'Ч', '$': 'Ш', 
          '}': 'Ь', '&': 'Ы', 'Q': 'Э', 'X': 'Ю', '{': 'Я', 'Y': 'Й'
      }, n_str = [];
    
      str = str.replace(/[ъь]+/g, '').replace(/й/g, 'i');
      
      for ( var i = 0; i < str.length; ++i ) {
        n_str.push(
                ru[ str[i] ]
            || ru[ str[i].toLowerCase() ] == undefined && str[i]
            || ru[ str[i].toLowerCase() ].toUpperCase()
        );
      }
    
    return n_str.join('');
}
  },
  created()
  {
    this.$i18n.locale = JSON.parse(localStorage.getItem('locale'));
  }
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }


h2 {
    display: block;
    text-align: center;
    color: rgb(7, 7, 6);
    font-size: 1.1em;
    margin-block-start: 0.83em;
    margin-block-end: 0.83em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold;
}

.row{
  align-content: center;
  display: flex;
  flex-wrap: wrap;
}

.no-padding {
  padding-left: 0;
  margin: 0;
  padding-right: 0;
}

.blue-color {
color:blue;
}
.green-color {
color:green;
}
.teal-color {
color:teal;
}
.yellow-color {
color:yellow;
}
.red-color {
color:red;
}

</style>
